class FilterList extends HTMLElement {
  constructor() {
    super();
    this.tit = this.querySelector('.filter-summary');
    this.content = this.querySelector('.filter-values');
    this.titIcon = this.querySelector('.filter-summary-icon');
  }
  connectedCallback() {
    this.computeDomHeight(this.content);
    this.tit.addEventListener('click', () => this.switchContent());
  }
  switchContent() {
    this.content.classList.toggle('active');
    this.titIcon.classList.toggle('active');
    if (this.hasAttribute('open')) {
      this.removeAttribute('open');
    } else {
      this.setAttribute('open', '');
    }
  }
  computeDomHeight(dom) {
    dom.style.height = 'auto';
    const height = getComputedStyle(dom).height;
    dom.style.removeProperty('height');
    dom.offsetHeight;
    dom.style.setProperty('--h', `${height}`);
  }
}
customElements.define('filter-list', FilterList);

class FilterShowMoreButton extends HTMLElement {
  constructor() {
    super();
    this.Items = document.querySelectorAll(`.my-main-collection .filter-list[data-index="${this.dataset.index}"] .filter-list-item.show-more`)
  }
  connectedCallback() {
    this.addEventListener('click', () => this.switchBtn());
  }
  switchBtn() {
    if (this.classList.contains('active')) {
      this.classList.remove('active');
      this.ItemsShow(false);
    } else {
      this.classList.add('active');
      this.ItemsShow(true);
    }
  }
  ItemsShow(is_show) {
    if (is_show) {
      this.Items.forEach(item => {
        item.classList.remove('filter-list-item-hidden');
      })
    } else {
      this.Items.forEach((item) => {
        item.classList.add('filter-list-item-hidden');
      })
    }
    if (this.Items.length > 0) {
      const fath = this.Items[0].closest('.filter-values');
      fath.style.height = 'auto';
      const height = getComputedStyle(fath).height;
      fath.style.removeProperty('height');
      fath.offsetHeight;
      fath.style.setProperty('--h', `${height}`);
    }
  }
}
customElements.define('filter-show-more-button', FilterShowMoreButton);

class MyMainCollection extends HTMLElement {
  constructor() {
    super();
    this.colorSwitch = this.querySelector('.color-switch');
    this.bannerTemp = this.querySelector('.add-banner');
  }
  connectedCallback() {
    this.reset();
  }
  reset() {
    this.setColor();
    this.addBanner();
  }
  getColorData() {
    if (this.colorSwitch.innerHTML && this.colorSwitch.innerHTML.trim() !== '') {
      return JSON.parse(this.colorSwitch.innerHTML.trim());
    } else {
      return [];
    }
  }
  setColor() {
    if (this.getColorData().length === 0) {
      return;
    }
    this.getColorData().forEach(item => {
      const filterLabel = document.querySelector(`.filter-color-checkbox[data-color="${item.source}"]`);
      if (filterLabel) {
        if (item.type === 'color') {
          filterLabel.style.setProperty('--color', item.destination);
        } else if (item.type === 'image') {
          filterLabel.style.setProperty('--img', `url(${item.destination})`);
        }
      }
    })
  }
  addBanner() {
    if (this.bannerTemp.innerHTML && this.bannerTemp.innerHTML.trim() !== '') {
      const bannerEle = this.bannerTemp.content.cloneNode(true).querySelectorAll('a');
      if (bannerEle.length <= 0) return;
      const productWrap = this.querySelector('.my-products');
      const products = this.querySelectorAll('.my-product');
      bannerEle.forEach((ele) => {
        const position = ele.dataset.position;
        if (products.length >= position) {
          productWrap.insertBefore(ele, products[position -1]);
        } else {
          productWrap.appendChild(ele);
        }
      })
    }
  }
}
customElements.define('my-main-collection', MyMainCollection);

class FilterPriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) =>
      element.addEventListener('change', this.onRangeChange.bind(this))
    );
    this.setMinAndMaxValues();
  }
  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }
  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }
  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));
    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}
customElements.define('filter-price-range', FilterPriceRange);

class FilterRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }
  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('my-filter-form') || document.querySelector('my-filter-form');
    form.onActiveFilterClick(event);
  }
}
customElements.define('filter-remove', FilterRemove);

class MyFilterForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.debouncedOnSubmit = MyFilterForm.debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));
  }
  static renderPage(searchParams, event, updateURLHash = true) {
    MyFilterForm.searchParamsPrev = searchParams;
    const sections = MyFilterForm.getSections();
    MyFilterForm.isLoading(true);
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;
      MyFilterForm.filterData.some(filterDataUrl) ? MyFilterForm.renderSectionFromCache(filterDataUrl, event) : MyFilterForm.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) MyFilterForm.updateURLHash(searchParams);
  }
  static renderSectionFromCache(filterDataUrl, event) {
    const html = MyFilterForm.filterData.find(filterDataUrl).html;
    MyFilterForm.renderFilters(html, event);
    MyFilterForm.renderProductGridContainer(html);
    MyFilterForm.renderProductCount(html);
    MyFilterForm.resetConfig();
  }
  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        MyFilterForm.filterData = [...MyFilterForm.filterData, { html, url }];
        MyFilterForm.renderFilters(html, event);
        MyFilterForm.renderProductGridContainer(html);
        MyFilterForm.renderProductCount(html);
        MyFilterForm.resetConfig();
      });
  }
  static renderFilters(html) {
    document.getElementById('MyFilterForm').innerHTML = new DOMParser() .parseFromString(html, 'text/html').getElementById('MyFilterForm').innerHTML;
    document.getElementById('MySortByForm').innerHTML = new DOMParser() .parseFromString(html, 'text/html').getElementById('MySortByForm').innerHTML;
  }
  static renderProductGridContainer(html) {
    document.getElementById('MyCollectionProducts').innerHTML = new DOMParser() .parseFromString(html, 'text/html').getElementById('MyCollectionProducts').innerHTML;
  }
  static renderProductCount(html) {
    document.getElementById('SortByProductCount').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('SortByProductCount').innerHTML;
    MyFilterForm.isLoading(false);
  }
  static resetConfig () {
    const MyMainCollection = document.querySelector('my-main-collection');
    MyMainCollection.reset();
  }
  onActiveFilterClick(event) {
    event.preventDefault();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    MyFilterForm.renderPage(url);
  }
  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('my-filter-form form');
    const forms = [];
    sortFilterForms.forEach((form) => {
      forms.push(this.createSearchParams(form));
    });
    this.onSubmitForm(forms.join('&'), event);
  }
  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }
  onSubmitForm(searchParams, event) {
    MyFilterForm.renderPage(searchParams, event);
  }
  static isLoading(loading = false) {
    const countEle = document.querySelector('#SortByProductCountAndLoading');
    countEle.classList.toggle('loading', loading);
  }
  static getSections() {
    return [
      {
        section: document.getElementById('my-product-grid').dataset.id,
      },
    ];
  }
  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : MyFilterForm.searchParamsInitial;
      if (searchParams === MyFilterForm.searchParamsPrev) return;
      MyFilterForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }
  static debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
MyFilterForm.filterData = [];
MyFilterForm.searchParamsInitial = window.location.search.slice(1);
MyFilterForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('my-filter-form', MyFilterForm);
MyFilterForm.setListeners();

const localStorage_myCompare = 'my-compare-selected'
class MyProductCompareSwitch extends HTMLElement {
  // 构造函数，初始化compareData和handle
  constructor() {
    super();
    // 从localStorage中获取compareData，如果不存在则初始化为空数组
    this.compareData = JSON.parse(localStorage.getItem(localStorage_myCompare)) || [];
    // 获取当前元素的handle
    this.handle = this.dataset.handle;
    // 获取当前元素的input元素
    this.inputEle = this.querySelector('input');
  }
  // 当元素被添加到DOM中时调用
  connectedCallback() {
    // 初始化
    this.init();
    // 绑定input事件
    this.inputEvent();
  }
  // 初始化函数，判断当前元素的handle是否在compareData中，如果是则将input元素设置为选中状态
  init () {
    // 如果localStorage中不存在compareData，则初始化为空数组
    if (!localStorage.getItem(localStorage_myCompare)) {
      localStorage.setItem(localStorage_myCompare, JSON.stringify([]));
    }
    // 如果compareData不为空且包含当前元素的handle，则将input元素设置为选中状态
    if (this.compareData.length > 0 && this.compareData.includes(this.handle)) {
      this.inputEle.checked = true;
    }
  }
  // 绑定input事件，当input元素状态改变时，更新localStorage中的compareData
  inputEvent() {
    // 绑定change事件
    this.querySelector('input').addEventListener('change', () => {
      // 从localStorage中获取compareData，如果不存在则初始化为空数组
      this.compareData = JSON.parse(localStorage.getItem(localStorage_myCompare)) || [];
      if (!this.inputEle.checked) {
        // 如果input元素未被选中，则从compareData中移除当前元素的handle
        this.compareData = this.compareData.filter(item => item !== this.handle);
      } else {
        this.compareData.push(this.handle);
      }
      localStorage.setItem(localStorage_myCompare, JSON.stringify(this.compareData));
    })
  }
}
customElements.define('my-product-compare-switch', MyProductCompareSwitch);

class MyProductColorOptions extends HTMLElement {
  constructor() {
    super();
    this.tempEle = this.querySelector('.my-product-color-options-template');
    this.formEle = this.querySelector('form');
    this.debouncedOnSelectProductImg = MyProductColorOptions.debounce((event) => {
      this.selectProductImg(event);
    }, 500);
    this.formEle.addEventListener('input', this.debouncedOnSelectProductImg.bind(this));
  }
  connectedCallback() {
    this.setColor();
    this.addTitle();
  }
  getColorData() {
    if (this.tempEle.innerHTML && this.tempEle.innerHTML.trim() !== '') {
      return JSON.parse(this.tempEle.innerHTML.trim());
    } else {
      return [];
    }
  }
  setColor() {
    if (this.getColorData().length === 0) return;
    this.getColorData().forEach(item => {
      const colorLabel = this.querySelector(`.my-product-color-option-label[data-color="${item.source}"]`);
      if (colorLabel) {
        if (item.type === 'color') {
          colorLabel.style.setProperty('--value', item.destination);
        } else if (item.type === 'image') {
          colorLabel.style.setProperty('--value', `url(${item.destination})`);
        }
      }
    })
  }
  selectProductImg (event) {
    event.preventDefault();
    const target = event.target;
    const ImgId = target.dataset.variantFeaturedMedia;
    if (!target && !ImgId) return;
    const activeImg = target.closest('.my-product').querySelector(`.my-product-image[data-media-id="${ImgId}"]`);
    if (!activeImg) return;
    this.removeOldActive();
    activeImg.classList.add('active');
  }
  removeOldActive() {
    const activeImgs = this.closest('.my-product').querySelectorAll('.my-product-image.active');
    if (activeImgs.length === 0) return;
    activeImgs.forEach(item => {
      item.classList.remove('active');
    })
  }
  addTitle() {
    const labelEles = this.querySelectorAll('.my-product-color-option-label');
    if (labelEles.length === 0) return;
    tippy(labelEles);
  }
  static debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('my-product-color-options', MyProductColorOptions);
